<template>
  <v-content
    v-intersect="{
      handler: showNavBar,
      options: {
        threshold: [0.1, 0.5, 1.0]
      }
    }"
    fluid
    class="px-0 py-0"
  >
    <v-main>
      <v-row
        class="py-12 d-flex d-sm-none"
      >
        <v-col cols="12" class="px-0 py-12">
          <!-- Mobile carousel -->
          <v-carousel
            id="small-carousel"
            height="auto"
            cycle
            :show-arrows="false"
            hide-delimiter-background
            delimiter-icon="mdi-minus"
          >
            <v-carousel-item
              v-for="(slide, i) in slides"
              :key="i"
            >
              <v-sheet
                color="gmWhitish"
                height="600px"
                tile
              >
                <v-img
                  :src="slide.image"
                  height="600px"
                  cover
                />
              </v-sheet>

              <div class="carousel-text">
                <v-row>
                  <v-col class="px-6">
                    <v-img class="icon-img" :src="slides[i].icon" height="6rem" width="6rem" />
                  </v-col>

                  <v-col cols="12">
                    <v-row class="service-card-text">
                      <v-col class="px-12">
                        <h2 class="gm-darkblue--text">{{slides[i].title}}</h2>
                        <p>{{slides[i].text}}</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-carousel-item>
          </v-carousel>

          <v-row justify="center" class="pt-1">
            <v-btn to="/services" color="gmYellow">
              <v-icon color="gmWhitish">mdi-cogs</v-icon>
              <span class="gm-whitish--text dosis btn-text ml-3">See More</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row
        class="py-12 d-none d-sm-flex"
      >
        <v-col cols="12" class="px-0 py-12">
          <!-- Desktop carousel -->
          <v-carousel
            id="large-carousel"
            height="auto"
            cycle
            :show-arrows="false"
            hide-delimiter-background
            delimiter-icon="mdi-minus"
          >
            <v-carousel-item
              v-for="(slide, i) in slides"
              :key="i"
            >
              <v-sheet
                color="gmWhitish"
                height="100vh"
                tile
              >
                <v-img
                  :src="slide.image"
                  height="100vh"
                  cover
                />
              </v-sheet>
            </v-carousel-item>
          </v-carousel>

          <div class="carousel-text">
            <v-row justify="center">
              <v-col v-for="(slide, i) in slides" :key="i" cols="3" class="mx-3">
                <v-card>
                  <v-row>
                    <v-col>
                      <v-img :src="slide.image" height="20vh" cover />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="px-6">
                      <v-img class="icon-img" :src="slide.icon" height="6rem" width="6rem" />

                      <v-row class="service-card-text">
                        <v-col>
                          <h2 class="gm-darkblue--text">{{slide.title}}</h2>
                          <p>{{slide.text}}</p>

                          <v-row justify="center">
                            <v-btn to="/services" class="service-btn" color="gmYellow">
                              <v-icon color="gmWhitish">mdi-cogs</v-icon>
                              <span class="gm-whitish--text dosis btn-text ml-3">See More</span>
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="px-0">
          <v-img :src="slideBottom" height="20vh" cover />
        </v-col>
      </v-row>
    </v-main>
  </v-content>
</template>

<script>
// slide images
import DesignImg from '../assets/images/services/design.jpg'
import ConstructionImg from '../assets/images/services/construction.png'
import MaintenanceImg from '../assets/images/services/maintenance.jpg'

// slide icons
import DesignIcon from '../assets/images/services/design-icon.svg'
import ConstructionIcon from '../assets/images/services/construction-icon.png'
import MaintenanceIcon from '../assets/images/services/maintenance-icon.png'

// slide bottom
import slideBottom from '../assets/images/services/slide-botttom.png'

export default {
  name: 'services-highlight',

  data: () => ({
    intersected: false,
    intersectionRatio: 0.1,
    slides: [
      {
        title: 'Design',
        text: 'We are involved in system and process design and planning with special attention to details. Our project team conducts thorough assessment for all intended work activities.',
        image: DesignImg,
        icon: DesignIcon
      },
      {
        title: 'Construction',
        text: 'We have years of experience in construction of bridges, buildings, roads, highways, EPC contracts, and other civil works and our excellent track record speaks for itself.',
        image: ConstructionImg,
        icon: ConstructionIcon
      },
      {
        title: 'Maintenance',
        text: 'Our protfolio will be incomplete without maintenance, this is the core aspect of our work activities. we handle plant maintenance, tank farm rehabilitation and civil maintenance.',
        image: MaintenanceImg,
        icon: MaintenanceIcon
      }
    ],
    slideBottom
  }),

  watch: {
    intersected () {
      const ROOT = this
      this.$store.dispatch('setValue', { name: 'showNavBar', newValue: ROOT.intersected })
      setTimeout(() => { ROOT.intersectionRatio = 0.1 }, 2000)
    }
  },

  methods: {
    showNavBar (entries, observer) {
      if (this.getScrollDirection === 'up' && entries[0].intersectionRatio < this.intersectionRatio) {
        this.intersected = false
      } else if (this.getScrollDirection === 'down' && entries[0].intersectionRatio >= this.intersectionRatio) {
        this.intersected = entries[0].intersectionRatio >= this.intersectionRatio
        this.intersectionRatio = 0.05

        // alert('Intersection ratio: ' + entries[0].intersectionRatio + ' Scroll direction ' + this.getScrollDirection)
      }
    }
  },

  mounted () {
    if (window.scrollY > window.innerHeight * 3) {
      this.intersected = true
    }
  }
}
</script>

<style scoped>
.icon-img {
  border: 5px solid white;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  transform: translateY(-55px);
  background-color: white;
}

.service-card-text {
  transform: translateY(-55px)
}

.service-btn {
  transform: translateY(72px);
}
</style>
